<template>
	<Col class="height-100 width-100 flex-justify-space-between version-history">
		<Col class="pa-4 overflow-y-auto height-100 width-100">
			<Row class="flex-align-center flex-justify-space-between mb-10">
				<Row class="task-log-title">Version history</Row>
				<AnemicButton @click="closeDrawer" rounded class="pa-0 close-button">x</AnemicButton>
			</Row>
			<WorkflowVersionHistoryItem
				:workflow="workflow"
				:key="workflowVersion.id"
				:workflowVersion="workflowVersion"
				v-for="workflowVersion in sortedVersionsList"
				:isCurrentDraftVersion="workflowDraftVersionId === workflowVersion.id"
				:isCurrentPublishedVersion="workflow.current_version === workflowVersion.id"
			/>
		</Col>
		<Col class="footer-container width-100 flex-centerize">
			<template v-if="isCurrentSelectedVersionDraft">
				<Row v-if="isLoading" class="flex-centerize with-100 mt-1">
					<AppLoader />
				</Row>
				<h3 v-else @click="restoreVersion" class="version-link reg">Save draft and create new version</h3>
			</template>
			<template v-else>
				<h5 class="mb-3">Your current draft will be saved</h5>
				<AnemicButton :loading="isLoading" :disabled="isLoading" @click="restoreVersion" class="px-5 restore-button" tile>
					Restore as new draft
				</AnemicButton>
			</template>
		</Col>
	</Col>
</template>

<script>
import { mapActionsShorthand } from '@/store/utils/mappers';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { getWorkflow } from '@/store/modules/workflows/getters';
import WorkflowVersionService from '@/components/WorkflowVersionHistory/workflow-version-service.js';
import { restoreSelectedWorkflowSpecificVersionAsDraft } from '@/store/modules/selectedWorkflow/actions';
import WorkflowVersionHistoryItem from '@/components/WorkflowVersionHistory/WorkflowVersionHistoryItem.vue';
export default {
	name: 'BuilderVersionHistory',
	props: {
		workflowId: { type: Number },
		versionId: { type: Number, required: true },
	},
	components: { WorkflowVersionHistoryItem },
	computed: {
		...mapGettersShorthand({ getWorkflow }),
		workflow() {
			return this.getWorkflow(this.workflowId);
		},
		workflowVersions() {
			return this.workflow.versions;
		},
		workflowVersionsWithoutDraft() {
			return this.workflowVersions.filter((version, i) => i !== this.currentDraftIndexInVersions);
		},
		workflowDraftVersionId() {
			return this.workflow.current_draft?.id;
		},
		currentDraftIndexInVersions() {
			return this.workflowVersions.findIndex((version) => version.id === this.workflowDraftVersionId);
		},
		workflowDraftVersion() {
			return { ...this.workflowVersions[this.currentDraftIndexInVersions], version: this.draftVersionNumber };
		},
		sortedVersionsList() {
			return [this.workflowDraftVersion, ...[...this.workflowVersionsWithoutDraft].reverse()].filter((version) => version);
		},
		hasWorkflowEverBeenPublished() {
			return this.workflow.is_published;
		},
		draftVersionNumber() {
			return WorkflowVersionService.getWorkflowDraftVersionNumber(this.workflow);
		},
		isCurrentSelectedVersionDraft() {
			return this.workflowDraftVersionId === this.versionId;
		},
	},
	methods: {
		...mapActionsShorthand({ restoreSelectedWorkflowSpecificVersionAsDraft }),
		closeDrawer() {
			this.$emit('close');
		},
		async restoreVersion() {
			const selectedVersion = this.workflowVersions.find((version) => version.id === this.versionId);
			const hasConfiguration = selectedVersion.user_specific_config_options || selectedVersion.general_config_options;
			try {
				this.isLoading = true;
				await WorkflowVersionService.restoreVersion({
					hasConfiguration,
					router: this.$router,
					version: this.versionId,
					workflowId: this.workflowId,
					navigateToVersionAfterCreation: !this.isCurrentSelectedVersionDraft,
					restoreSelectedWorkflowSpecificVersionAsDraft: this.restoreSelectedWorkflowSpecificVersionAsDraft,
				});
				this.$toast.success('Version restored successfully.');
			} catch (error) {
				console.error(error);
				this.$toast.error('Failed to restore version, please try again later.');
			} finally {
				this.isLoading = false;
			}
		},
	},
	created() {
		this.$emit('closeRightSideBar');
	},
	data() {
		return {
			isLoading: false,
		};
	},
};
</script>
<style scoped lang="scss">
.task-log-title {
	font-size: 20px;
	font-weight: medium;
	color: var(--primary-font-color);
}
.close-button {
	width: 22px !important;
	height: 22px !important;
	font-size: 12px !important;
	color: #5a677c !important;
	font-weight: normal !important;
	background: #f5f7fa !important;
	border: 1px solid #e7eaf3 !important;
}
.footer-container {
	min-height: 90px;
	max-height: 90px;
	background: #ffffff;
	box-shadow: 0px -5px 10px #80899c80;
}
.restore-button {
	height: 40px !important;
	font-size: 14px !important;
	border-radius: 10px !important;
	color: var(--white) !important;
	font-weight: normal !important;
	text-transform: none !important;
	background: #5858ec !important;
}
.version-history {
	border-right: 1px solid #dce0e9;
}
.version-link {
	cursor: pointer;
	color: #5858ec;
	width: fit-content;
	text-decoration: underline;
}
</style>
